// **************************
// GENDER
// **************************

export const getGenderList = (language) => {
    switch (language) {
        case 'pt':
            return GENDER_LIST;
        break;
        case 'en':
            return EN_GENDER_LIST;
        break;
        case 'es':
            return ES_GENDER_LIST;
        break;
        case 'fr':
            return FR_GENDER_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedGenderOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < GENDER_LIST.length; i++) {
                if(GENDER_LIST[i].code === value) {
                    return { code: value, name: GENDER_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_GENDER_LIST.length; i++) {
                if(EN_GENDER_LIST[i].code === value) {
                    return { code: value, name: EN_GENDER_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_GENDER_LIST.length; i++) {
                if(ES_GENDER_LIST[i].code === value) {
                    return { code: value, name: ES_GENDER_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_GENDER_LIST.length; i++) {
                if(FR_GENDER_LIST[i].code === value) {
                    return { code: value, name: FR_GENDER_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const GENDER_LIST = [
    { name: 'Feminino', code: 'Feminino' },
    { name: 'Masculino', code: 'Masculino' }
];

export const EN_GENDER_LIST = [
    { name: 'Female', code: 'Feminino' },
    { name: 'Male', code: 'Masculino' }
];

export const ES_GENDER_LIST = [
    { name: 'Femenino', code: 'Feminino' },
    { name: 'Masculino', code: 'Masculino' }
];

export const FR_GENDER_LIST = [
    { name: 'Féminin', code: 'Feminino' },
    { name: 'Masculin', code: 'Masculino' }
];

// **************************
// CONTACT TYPE
// **************************

export const getContactTypeList = (language) => {
    switch (language) {
        case 'pt':
            return CONTACT_TYPE_LIST;
        break;
        case 'en':
            return EN_CONTACT_TYPE_LIST;
        break;
        case 'es':
            return ES_CONTACT_TYPE_LIST;
        break;
        case 'fr':
            return FR_CONTACT_TYPE_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedContactTypeOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < CONTACT_TYPE_LIST.length; i++) {
                if(CONTACT_TYPE_LIST[i].code === value) {
                    return { code: value, name: CONTACT_TYPE_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let i = 0; i < EN_CONTACT_TYPE_LIST.length; i++) {
                if(EN_CONTACT_TYPE_LIST[i].code === value) {
                    return { code: value, name: EN_CONTACT_TYPE_LIST[i].name };
                }
            }
        break;
        case 'es':
            for (let i = 0; i < ES_CONTACT_TYPE_LIST.length; i++) {
                if(ES_CONTACT_TYPE_LIST[i].code === value) {
                    return { code: value, name: ES_CONTACT_TYPE_LIST[i].name };
                }
            }
        break;
        case 'fr':
            for (let i = 0; i < FR_CONTACT_TYPE_LIST.length; i++) {
                if(FR_CONTACT_TYPE_LIST[i].code === value) {
                    return { code: value, name: FR_CONTACT_TYPE_LIST[i].name };
                }
            }
        break;
        default:
            break;
    }
}

export const CONTACT_TYPE_LIST = [
    { name: 'E-mail', code: 'E-mail' },
    { name: 'Telefone móvel', code: 'Telefone móvel' },
    { name: 'Telefone fixo', code: 'Telefone fixo' }
];

export const EN_CONTACT_TYPE_LIST = [
    { name: 'E-mail', code: 'E-mail' },
    { name: 'Mobile phone', code: 'Telefone móvel' },
    { name: 'Telephone', code: 'Telefone fixo' }
];

export const ES_CONTACT_TYPE_LIST = [
    { name: 'Correo electrónico', code: 'E-mail' },
    { name: 'Teléfono móvil', code: 'Telefone móvel' },
    { name: 'Teléfono fijo', code: 'Telefone fixo' }
];

export const FR_CONTACT_TYPE_LIST = [
    { name: 'E-mail', code: 'E-mail' },
    { name: 'Téléphone portable', code: 'Telefone móvel' },
    { name: 'Téléphone fixe', code: 'Telefone fixo' }
];

// **************************
// STREET TYPE
// **************************

export const STREET_TYPE_LIST = [
    { name: "Alameda", code: "AL" },
    { name: "Avenida", code: "AV" },
    { name: "Azinhaga", code: "AZ" },
    { name: "Bairro", code: "BR" },
    { name: "Beco", code: "BC" },
    { name: "Calçada", code: "CC" },
    { name: "Caminho", code: "CAM" },
    { name: "Casal", code: "CSL" },
    { name: "Edíficio", code: "EDF" },
    { name: "Estrada", code: "ESTR" },
    { name: "Largo", code: "LG" },
    { name: "Loteamento", code: "LOTEAM" },
    { name: "Parque", code: "PQ" },
    { name: "Praça", code: "PC" },
    { name: "Praceta", code: "PCT" },
    { name: "Prolongamento", code: "PROLNG" },
    { name: "Quinta", code: "QTA" },
    { name: "Rotunda", code: "ROT" },
    { name: "Rua", code: "R" },
    { name: "Transversal", code: "TRANSV" },
    { name: "Travessa", code: "TV" },
    { name: "Urbanização", code: "URB" },
    { name: "Vila", code: "VL" },
    { name: "Vivenda", code: "VV" },
    { name: "Zona", code: "ZN" }
];